module.exports = __webpack_public_path__ + "static-portal/img/new8-5.9e691b2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/new8-5.png
// module id = fAGX
// module chunks = 4